import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import DropdownOutlet from 'components/Fields/ReduxForm/DropdownOutlet';
import DropdownSelect from 'components/Fields/ReduxForm/DropdownSelect';
import DropdownCalendar from 'components/Fields/ReduxForm/DropdownCalendar';
import MenuTitle from 'components/MenuTitle';
import { ActionBarWrapper } from 'components/wrappers/pages';
import LineNavbar from 'components/LineNavbar';
import styles from './ActionBar.css';

class ActionBar extends React.Component {
  render() {
    const { outlets } = this.props;
    const status = [
      {
        id: '0',
        name: 'All',
      },
      {
        id: '1',
        name: 'Completed',
      },
      {
        id: '2',
        name: 'Cancelled',
      },
    ];
    const navigations = [
      {
        id: 'transaction-nav-bar',
        href: '/table-management/report',
        label: 'Transaction',
      },
      {
        id: 'void-item-nav-bar',
        href: '/table-management/void-item-report',
        label: 'Void Items',
      },
    ];
    return (
      <div className={styles.wrapper}>
        <MenuTitle menuTitle="Table Report" />
        <ActionBarWrapper>
          <div className={`col-sm-12 col-xs-12 ${styles['action-bar']}`}>
            <div className={styles['btn-outlet']}>
              <Field
                name="outletIds"
                component={DropdownOutlet}
                outlets={outlets}
                onChangeOutletIds={this._onChangeOutletIds}
              />
            </div>
            <div className={styles['btn-search']}>
              <Field
                component={DropdownCalendar}
                name="date"
                onChange={this._onChangeDate}
                updateServerOnChange
              />
            </div>
            <div className={styles['btn-search']}>
              <Field
                name="statusIds"
                component={DropdownSelect}
                options={status}
                onChange={this._onChangeStatus}
              />
            </div>
          </div>
        </ActionBarWrapper>
        <div className="row">
          <div className="col-xs-12">
            <LineNavbar
              links={navigations}
              pathname={this.props.location.pathname}
              forceHighlight={this.props.forceHighlight}
              onClickLink={this._onClickLink}
            />
          </div>
        </div>
      </div>
    );
  }

  _onChangeStatus = (event, statusId) => {
    this.props.onChangeStatus(statusId);
  };

  _onChangeOutletIds = outletIds => {
    this.props.onChangeOutlet(outletIds);
  };

  _onChangeDate = ({ startDate, endDate, startHour, endHour, allDay }) => {
    this.props.onChangeDate({ startDate, endDate, startHour, endHour, allDay });
  };

  _onClickExport = () => {};
}

const mapForm = {
  form: 'search',
};

function mapStateToProps(state) {
  const {
    groups,
    summary,
    groupDetail,
    currentPage,
    totalPage,
    outlets,
  } = state.tableManagement.group;
  return {
    outlets,
    groups,
    groupDetail,
    currentPage,
    totalPage,
    summary,
    userPropertiesLoaded: state.userProperties.loaded,
  };
}

export default reduxForm(mapForm)(connect(mapStateToProps)(ActionBar));
